import { render, staticRenderFns } from "./StepThree.vue?vue&type=template&id=130438b5&scoped=true"
import script from "./StepThree.vue?vue&type=script&lang=js"
export * from "./StepThree.vue?vue&type=script&lang=js"
import style0 from "./StepThree.vue?vue&type=style&index=0&id=130438b5&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130438b5",
  null
  
)

export default component.exports